import React from "react";
import { Users, Award, TrendingUp, Shield, Target, Heart, Zap, HandshakeIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { AboutPageSEO } from "../components/SEO";
import "./AboutPage.css";
// import SouthAfricaMap from "../components/SouthAfricaMap";



export default function AboutPage() {
  return (
    
    <div className="about-page">
    <AboutPageSEO />
    {/* Hero Section */}
    <section className="about-hero">
     <img 
    src= "/hero.jpg" 
    alt="About background" 
    className="hero-background-img"
     />
    <div className="hero-overlay"></div>
    <div className="hero-content">
    <div>
      <h1 className="page-title">About Migarda</h1>
      <p className="page-sub">
        Connecting South Africa, one customer at a time
      </p>
    </div>
    <div></div>
  </div>
</section>

      {/* Who We Are */}
      <section className="who-we-are">
        <div className="container">
          <div className="content-grid">
            <div className="content-text">
              <h2 className="section-title">Who We Are</h2>
              <p className="section-paragraph">
                <strong>Migarda Investments CC</strong> is a proud franchisee and authorized partner of{" "}
                <strong>Telkom</strong>, operating under the brand name <em>Telkom</em>.
                We bring telecommunications excellence to communities across South Africa through our
                growing network of store locations.
              </p>
              <p className="section-paragraph">
                With a strong presence in <strong>KwaZulu-Natal, Western Cape, and Northern Cape</strong>, 
                we are committed to providing exceptional customer service and connecting South Africans 
                with the best mobile and telecommunications solutions.
              </p>
              <p className="section-paragraph">
                From the energy of our retail teams to the passion of our leadership, we're driven by one 
                goal — <strong>connecting people</strong> and helping them thrive in a connected world.
              </p>
            </div>
            <div className="content-image">
              <img
                src="Telkom.jpg"
                alt="Telkom logo"
                className="hero-logo"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card">
              <Target className="mv-icon" />
              <h3>Our Mission</h3>
              <p>
                To deliver world-class telecommunications experiences — from mobile plans to
                in-store support — while creating meaningful employment opportunities and empowering local
                communities through innovation, service, and heart.
              </p>
            </div>
            <div className="mv-card">
              <TrendingUp className="mv-icon" />
              <h3>Our Vision</h3>
              <p>
                To be the leading telecommunications partner in South Africa, recognized for 
                exceptional customer service, innovation, and our commitment to connecting 
                communities and empowering people.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Journey Section */}
      <section className="roadmap">
        <div className="container">
          <h2 className="section-title">
            Our <span className="highlight">Journey</span>
          </h2>

          <div className="roadmap-wrapper">
            {/* SVG Curved Path */}
            <svg
              className="roadmap-path"
              viewBox="0 0 1200 400"
              preserveAspectRatio="none"
            >
              <path
                id="curvePath"
                d="M 50 350 
                   C 300 50, 900 50, 1150 350"
                fill="none"
                stroke="rgba(255,255,255,0.4)"
                strokeWidth="6"
                strokeLinecap="round"
              />
              {/* Moving dot follows the path inside the SVG so it scales properly */}
              <circle className="moving-dot-svg" r="10" fill="#fbbf24">
                <animateMotion dur="15s" repeatCount="indefinite">
                  <mpath xlinkHref="#curvePath" />
                </animateMotion>
              </circle>
            </svg>

            {/* Milestones */}
<div className="milestones">
  <div className="milestone" style={{ left: "5%", top: "72%" }}>
    <h3>2009</h3>
    <p>Migarda Investments launched with 4 stores under the Virgin Mobile brand in KZN and WC.</p>
  </div>

  <div className="milestone" style={{ left: "15%", top: "28%" }}>
    <h3>2010</h3>
    <p>Expanded to 5 stores and opened our Cape Town office.</p>
  </div>

  <div className="milestone" style={{ left: "25%", top: "15%" }}>
    <h3>2012</h3>
    <p>Moved over from Virgin Mobile to Telkom.</p>
  </div>

  <div className="milestone" style={{ left: "37%", top: "35%" }}>
    <h3>2019</h3>
    <p>Welcomed the addition of 4 more stores.</p>
  </div>

  <div className="milestone" style={{ left: "50%", top: "12%" }}>
    <h3>2020</h3>
    <p>Expanded with 20 Mini Stores and Kiosks.</p>
  </div>

  <div className="milestone" style={{ left: "62%", top: "30%" }}>
    <h3>2021</h3>
    <p>Expanded into the North Cape with 3 Stores and 2 Kiosks.</p>
  </div>

  <div className="milestone" style={{ left: "74%", top: "18%" }}>
    <h3>2022</h3>
    <p>Opened our first call centre.</p>
  </div>

  <div className="milestone" style={{ left: "86%", top: "40%" }}>
    <h3>2023</h3>
    <p>Multiple new sites and second call centre.</p>
  </div>

  <div className="milestone" style={{ left: "95%", top: "68%" }}>
    <h3>2024-2026</h3>
    <p>Started a dedicated Business Division and multiple new store openings bring our count to 45 and counting...</p>
  </div>
</div>
          </div>
        </div>
      </section>

      {/* Physical Presence */}
      <section className="physical-presence">
        <div className="container">
          <div className="physical-grid">
            <div className="physical-text">
              <h2 className="physical-title">
                Physical <span className="presence-highlight">Presence</span>
              </h2>
              <div className="physical-box">
                <p className="physical-description">
                  With stores across KwaZulu-Natal, Western Cape, and Northern Cape, 
                  we serve communities throughout South Africa with exceptional telecommunications services.
                </p>
              </div>
            </div>
            <div className="map-embed">
          <iframe
            title="Migarda Store Locations"
          src="/storemap.html"
            width="100%"
            height="450"
            style={{ border: 0 }}
            loading= "eager"
            referrerPolicy="no-referrer-when-downgrade">

          </iframe>
          
</div>
          </div>
        </div>
      </section>

      {/* Our Core Values */}
      <section className="why-join">
        <div className="container">
          <h2 className="section-title-center">Our Core Values</h2>
          <p className="section-subtitle-center">
            The principles that guide everything we do and define who we are as a company
          </p>
          
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon blue">
                <Heart />
              </div>
              <h4>Customer First</h4>
              <p>Every decision we make starts with our customers. Their satisfaction and success drive our business forward.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon purple">
                <Shield />
              </div>
              <h4>Integrity & Trust</h4>
              <p>We operate with honesty and transparency, building lasting relationships based on trust and ethical business practices.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon blue">
                <Zap />
              </div>
              <h4>Innovation</h4>
              <p>We embrace new technologies and ideas to deliver cutting-edge telecommunications solutions to our communities.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon purple">
                <Award />
              </div>
              <h4>Excellence</h4>
              <p>We strive for the highest standards in service delivery, ensuring quality in every customer interaction.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon blue">
                <Users />
              </div>
              <h4>Community Impact</h4>
              <p>We're committed to making a positive difference in the communities we serve through job creation and empowerment.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon purple">
                <HandshakeIcon />
              </div>
              <h4>Partnership</h4>
              <p>As a proud Telkom franchisee, we leverage strong partnerships to deliver world-class telecommunications services.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Partners Section */}
      <section className="our-partners">
        <div className="container">
          <h2 className="section-title-center">Product Partners</h2>
          <p className="section-subtitle-center">
            With locations across South Africa, we offer a wide range of mobile devices and accessories through our retail outlets.
          </p>
          
          <div className="partners-grid">
            <div className="partner-logo">
              <img src="/huawei.jpg" alt="Huawei" />
            </div>
            <div className="partner-logo">
              <img src="/samsung.jpg" alt="Samsung" />
            </div>
            <div className="partner-logo">
              <img src="/oppo.jpg" alt="Oppo" />
            </div>
            <div className="partner-logo">
              <img src="/honor.jpg" alt="Honor" />
            </div>
            <div className="partner-logo">
              <img src="/apple.png" alt="Apple" />
            </div>
            <div className="partner-logo">
              <img src="/vivo.png" alt="Vivo" />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-teams">
        <div className="container">
          <h2>Experience the Migarda Difference</h2>
          <p>Visit any of our locations and discover why we're South Africa's trusted Telkom partner</p>
          <Link to="/locations" className="cta-btn secondary">
            Find a Store Near You
          </Link>
        </div>
      </section>
    </div>
  );
}